module.exports = __webpack_public_path__ + "img/logo-dark.7efcc3a0.gif";